import React from 'react';
import { motion } from 'framer-motion';
const OPPORTUNITY_IMAGE = 'https://cdn.magicpatterns.com/uploads/m7Kg7pBU1ez95Rbcd91yvZ/Gemini_Generated_Image_wlffbfwlffbfwlff.png';
export function OpportunitySection() {
  return <section className="bg-white pt-0 mt-0 pb-16" data-id="element-184">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-185">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8" data-id="element-186">
          <span className="inline-block text-sm md:text-base font-bold uppercase tracking-wider bg-[#FFF8F0] px-6 py-2.5 rounded-full border border-[#E8D5C4]/50" style={{
          background: 'linear-gradient(135deg, #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent'
        }} data-id="element-187">
            APROVECHA ESTA NUEVA TENDENCIA DE ORIGEN TAIWANÉS
          </span>
        </motion.h2>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} data-id="element-188">
          <img src={OPPORTUNITY_IMAGE} alt="Oportunidad Bubble Tea" className="w-full h-auto block mx-auto" data-id="element-189" />
        </motion.div>
      </div>
    </section>;
}